import { useRef, useState } from "react";
import Icon from "../../common/components/Icon";
import Button from "./Button";
import { Input } from "./Form";

const AddToCartButton = ({
  size = "sm",
  quantity: defaultQuantity = 1,
  onAddToCart,
  children,
}: {
  size?: "sm" | "lg";
  quantity?: number;
  onAddToCart: (quantity: number) => void;
  children?: React.ReactNode;
}) => {
  const inputElement = useRef(null);
  const [quantity, setQuantity] = useState(defaultQuantity);

  const onIncrease = (e) => {
    e.preventDefault();
    const value = Math.abs(quantity + 1);
    inputElement.current.value = value;
    setQuantity(value);
  };

  const onDecrease = (e) => {
    e.preventDefault();
    const value = Math.abs(quantity - 1);
    inputElement.current.value = value;
    setQuantity(value);
  };

  const onBlur = (e) => {
    e.preventDefault();
    inputElement.current.value = quantity;
  };

  const onChange = (e) => {
    setQuantity(Math.abs(parseInt(e.target.value, 10) || 0));
  };

  const onConfirm = (e) => {
    e.preventDefault();
    onAddToCart(quantity);
    setQuantity(defaultQuantity);
  };

  return (
    <div data-size={size}>
      <div className="add-to-cart-wrapper">
        <div className="add-to-cart-control d-flex justify-content-between align-items-center">
          <button
            className="no-button border-left-radius"
            aria-label="Decrease cart item"
            type="button"
            onClick={onDecrease}
            disabled={quantity === 0}
          >
            <Icon icon="minus" />
          </button>
          <Input
            ref={inputElement}
            type="text"
            pattern="\d+"
            className="form-field border border-radius"
            defaultValue={defaultQuantity}
            min={0}
            onChange={onChange}
            onBlur={onBlur}
            inputMode="numeric"
          />
          <button
            className="no-button border-right-radius"
            aria-label="Increase cart item"
            type="button"
            onClick={onIncrease}
          >
            <Icon icon="plus" />
          </button>
        </div>
        <Button
          icon={<Icon icon="cart" data-icon-position="center" />}
          onClick={onConfirm}
          appearance="secondary"
        >
          {children}
        </Button>
      </div>
    </div>
  );
};

export default AddToCartButton;
